<template>
  <div class="container-fluid bg-info text-white">
    <div class="row title-card">
      <div class="col-10">
        <b-link v-if="level == 'supervisor'" :to="{ name: 'ranking' }"><span><icon name="cog" scale="2.5" spin v-show="spinner"></icon><icon name="arrow-circle-left" scale="2.5" v-show="back"></icon></span><h4 class="text-truncate">{{ score.nm_store }}</h4></b-link>
        <b-link v-if="level == 'store'" :to="{ name: 'home' }"><span><icon name="cog" scale="2.5" spin v-show="spinner"></icon><icon name="arrow-circle-left" scale="2.5" v-show="back"></icon></span></b-link>
      </div>
      <div class="col-2 text-right"><b-link class="text-white" :to="{ name: 'home' }"><icon name="times" scale="2"></icon></b-link></div>
    </div>
    <div class="row score">
      <div class="col-6 col-md-5 col-lg-4 col-xl-4 offset-md-1 offset-lg-2 offset-xl-2"><span>{{ score.ranking }}º</span></div>
      <div class="col-6 col-md-5 col-lg-4 col-xl-4"><p><strong>{{ score.score }}</strong> Score</p></div>
    </div>
    <template v-for="(group, index) in score.groups" v-if="group.view == 'S'">
      <div class="row mt-4" v-bind:key="'g'+index">
        <div class="col-md-10 col-lg-8 col-xl-7 offset-md-1 offset-lg-2 offset-xl-3"><h5>{{ group.nm_group }}</h5></div>
      </div>
      <div class="row mt-2" v-for="check in group.checks" v-bind:key="check.id_check">
        <div class="col-2 col-md-1 col-lg-1 offset-md-2 offset-lg-3 offset-xl-3 text-center">{{ check.score }}</div>
        <div class="col-8 col-md-6 col-lg-4">{{ check.nm_check }}</div>
        <div class="col-2 col-md-1 col-lg-1 text-right"><b-link class="text-white" :to="{ name: 'history', params: { store: score.id_store, check: check.id_check }}"><icon name="info-circle" scale="2"></icon></b-link></div>
      </div>
    </template>
  </div>
</template>

<script>
import { http } from '../http'
import swal from 'sweetalert2'
import Icon from 'vue-awesome'

export default {
  components: { Icon },
  data () {
    return {
      level: localStorage.getItem('level'),
      spinner: true,
      back: false,
      score: []
    }
  },
  beforeCreate: function() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home');
  },
  mounted () {
    // Verifica se está definida a informação da loja.
    if (this.$route.params.store) {
      // Armazenando a loja no localStorage para o caso de reloads.
      localStorage.setItem('id_store', this.$route.params.store)
      // Consumindo o WS.
      http.get('/ranking/score/'+this.$route.params.store).then(response => { this.spinner = false; this.back = true; this.score = response.data; })
    }
    // Parâmetros não definidos na rota.
    else {
      // Verifica se existe a última loja visitada no localStorage.
      if (localStorage.getItem('id_store')) {
        // Consumindo o WS com a loja armazenada no localStorage.
        http.get('/ranking/score/'+localStorage.getItem('id_store')).then(response => { this.spinner = false; this.back = true; this.score = response.data; })
      }
      else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped>
.container-fluid { min-height:100vh; }
.container-fluid .title-card { padding:20px 0; }
.container-fluid .title-card span { display:block; width:40px; height:40px; float:left; border-radius:20px; font-size:20px; color:#17A2B8; background:#FFF; line-height:40px; text-align:center; margin-right:24px; }
.container-fluid .title-card h4 { font-size:1.5em; color:#FFF; line-height:40px; }

.score { text-align:center; }
.score span { display:block; height:140px; background:url('http://api.checkpoint.recco.com.br/image_recco/trophy.png') no-repeat center; background-size:100px 100px; font-size:30px; padding-top:32px; opacity:0.3; }
.score p { text-transform:uppercase; padding-top:22px; }
.score p strong { display:block; font-size:72px; line-height:70px; }


</style>



// WEBPACK FOOTER //
// src/components/Score.vue